<!-- 官方皮套组件 -->
<template>
  <div class="offical-live2d">
    <el-card class="section-title-card">
      <div class="section-main-title">官方皮套</div>
      <div class="section-description">
        雪音官方皮套，按顺序排列，仅换衣服非整个重绘视为同皮肤，而非新皮套
      </div>
    </el-card>

    <!-- 浮动导航栏组件 -->
    <nav-menu :models="models" :show-back-to-top="showBackToTop" :key="'official'"></nav-menu>
    <!-- 模型卡片列表组件 -->
    <model-card v-for="model in models" :key="model.id" :model="model"></model-card>
  </div>
</template>

<script>
import ModelCard from './ModelCard.vue'; // 引入模型卡片组件
import NavMenu from '@/components/NavMenu.vue';

export default {
  name: 'OfficialLive2D',
  components: {
    ModelCard,
    NavMenu
  },
  data() {
    return {
      // 控制回到顶部按钮显示
      showBackToTop: false,
      // 统一格式的模型列表数据（适配ModelCard组件）
      models: [
        {
          id: 'original',
          name: '初代模型',
          carouselItems: [
            { title: "雪音-初代模型-背带裤", image: require("../assets/雪音-初代模型01.jpg") },
            { title: "雪音-初代模型-西装问号表情", image: require("../assets/雪音-初代模型02.png") },
            { title: "雪音-初代模型-西装星星眼", image: require("../assets/雪音-初代模型03.png") },
            { title: "雪音-初代模型-西装哭哭脸", image: require("../assets/雪音-初代模型04.jpg") },
            { title: "雪音-初代模型-西装手持麦克风", image: require("../assets/雪音-初代模型05.png") },
            { title: "雪音-初代模型-西装眼里有钱", image: require("../assets/雪音-初代模型06.png") },
            { title: "雪音-初代模型-西装眼晕晕", image: require("../assets/雪音-初代模型07.jpg") },
          ],
          downloadText: '下载图片',
          infoItems: [
            { label: '类型', value: 'Q版' },
            { label: '昵称', value: '小鼻嘎、小宝' },
            { label: '释出时间', value: '2024年6月21日' },
          ]
        },
        {
          id: 'child',
          name: '幼年体',
          carouselItems: [
            { title: "雪音-幼年体-雪小音", image: require("../assets/雪音-幼年体-雪小音.jpg") },
            { title: "雪音-幼年体-小菠萝", image: require("../assets/雪音-幼年体-小菠萝.png") },
            { title: "雪音-幼年体-新年衣装01", image: require("../assets/雪音-幼年体-新年衣装01.png") },
            { title: "雪音-幼年体-新年衣装02", image: require("../assets/雪音-幼年体-新年衣装02.png") },
            { title: "雪音-幼年体-新年衣装03", image: require("../assets/雪音-幼年体-新年衣装03.png") },
            { title: "雪音-幼年体-新年衣装04", image: require("../assets/雪音-幼年体-新年衣装04.png") },
            { title: "雪音-幼年体-新年衣装05", image: require("../assets/雪音-幼年体-新年衣装05.png") },
            { title: "雪音-幼年体-新年衣装06", image: require("../assets/雪音-幼年体-新年衣装06.png") },
            { title: "雪音-幼年体-新年衣装07", image: require("../assets/雪音-幼年体-新年衣装07.png") },
            { title: "雪音-幼年体-新年衣装08", image: require("../assets/雪音-幼年体-新年衣装08.png") },
            { title: "雪音-幼年体-新年衣装09", image: require("../assets/雪音-幼年体-新年衣装09.png") },
          ],
          downloadText: '下载图片',
          infoItems: [
            { label: '类型', value: '幼年体' },
            { label: '昵称', value: '雪小音、白月光' },
            { label: '释出时间', value: '2024年7月20日' },
            { label: '', value: '2026年2月16日,过年新装释出' }
          ]
        },
        {
          id: 'adult',
          name: '成皮',
          carouselItems: [
            { title: "雪音-带外套", image: require("../assets/雪音-成年体-带外套.jpg") },
            { title: "雪音-无外套", image: require("../assets/雪音-成年体-无外套.jpg") },
            { title: "雪音-新年衣装01", image: require("../assets/雪音-成年体-新年衣装01.png") },
            { title: "雪音-新年衣装02", image: require("../assets/雪音-成年体-新年衣装02.png") },
            { title: "雪音-新年衣装03", image: require("../assets/雪音-成年体-新年衣装03.png") },
            { title: "雪音-新年衣装04", image: require("../assets/雪音-成年体-新年衣装04.png") },
            { title: "雪音-新年衣装05", image: require("../assets/雪音-成年体-新年衣装05.png") },
            { title: "雪音-新年衣装06", image: require("../assets/雪音-成年体-新年衣装06.png") },
            { title: "雪音-新年衣装07", image: require("../assets/雪音-成年体-新年衣装07.png") },
          ],
          downloadText: '下载图片',
          infoItems: [
            { label: '类型', value: '成皮' },
            { label: '昵称', value: '哥酱' },
            { label: '释出时间', value: '2025年4月27日' },
            { label: '', value: '2026年2月16日释出，新衣装释出' },
          ]
        },
        {
          id: 'adult-2nd',
          name: '成皮二代',
          carouselItems: [
            { title: "雪音-带外套", image: require("../assets/雪音-成年体二代01.png") },
          ],
          downloadText: '下载图片',
          infoItems: [
            { label: '类型', value: '成皮' },
            { label: '昵称', value: '二哥、雪大缸、缸子' },
            { label: '释出时间', value: '2025年10月5日' },
          ]
        }
      ]
    };
  },
  methods: {
    // 回到顶部功能（和饭制组件保持一致）
    scrollToTop() {
      // 查找实际的滚动容器（main-content）
      const scrollContainer = document.querySelector('.main-content');

      if (scrollContainer) {
        // 优先滚动到main-content容器的顶部
        scrollContainer.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } else {
        // 如果找不到main-content容器，则回退到滚动整个窗口
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    // 监听滚动事件（控制回到顶部按钮显示）
    handleScroll() {
      this.showBackToTop = window.pageYOffset > 300;
    }
  },
  // 生命周期钩子
  mounted() {
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll);
    // 初始化检测
    this.handleScroll();
  },
  // 组件卸载时移除监听
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>
.offical-live2d {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.section-title-card {
  text-align: center;
  margin-bottom: 30px;
  border-radius: 10px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.section-main-title {
  font-size: 28px;
  color: #ffad32;
  margin-bottom: 10px;
  letter-spacing: 2px;
  font-weight: bold;
}

.section-description {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

.back-to-top {
  position: fixed;
  right: 40px;
  bottom: 40px;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #e4e7ed;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 18px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  z-index: 999;
}

.back-to-top:hover {
  background: #fff;
  color: #ffad32;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

@media (max-width: 768px) {
  .offical-live2d {
    padding: 10px;
  }

  .back-to-top {
    right: 20px;
    bottom: 10px;
    width: 40px;
    height: 40px;
    font-size: 18px;
  }
}

@media (min-width: 769px) {
  .offical-live2d {
    margin: 0 auto;
    max-width: 1200px;
  }
}
</style>